<!-- 商家分布图表 -->
<template>
  <div class="com-container" style="width: 120%; height: 120%">
    <div class="com-chart" ref="map_ref"></div>
  </div>
</template>

<script>
import axios from "axios";
import china from "./china.js";
export default {
  data() {
    return {
      chartInstance: null,
      allData: null,
      mapData: {}, // 所获取的省份的地图矢量数据
    };
  },
  mounted() {
    this.initChart();
    this.getData();
    window.addEventListener("resize", this.screenAdapter);
    this.screenAdapter();
  },
  destroyed() {
    window.removeEventListener("resize", this.screenAdapter);
  },
  methods: {
    async initChart() {
      this.chartInstance = this.$echarts.init(this.$refs.map_ref, "chalk");
      this.$echarts.registerMap("yancheng", china.mapData);
      const initOption = {
        geo: {
          type: "map",
          map: "yancheng",
          top: "0%",
          left: "27%",
          bottom: "20%",
          label: {
            show: true,
            color: "#04D8DF",
          },
          zoom: 0.9,
          emphasis: {
            label: {
              show: true,
              color: "#fff",
            },
            itemStyle: {
              areaColor: "#666",
              borderColor: "#333",
            },
          },

          itemStyle: {
            areaColor: "#666",
            borderColor: "#999",
            borderWidth: 2,
          },
          tooltip: {
            trigger: "item",
          },
        },
        legend: {
          left: "5%",
          bottom: "20%",
          orient: "vertical",
        },
      };
      this.chartInstance.setOption(initOption);
    },
    async getData() {
      const res = await axios.get(this.$api.xYNumber);
      this.allData = res.data.data;
      this.updateChart();
    },
    updateChart() {
      // 处理图表需要的数据
      // 图例的数据
      // 半透明的颜色值
      let tempSeriesArr = this.allData.map((item) => {
        // return的这个对象就代表的是一个类别下的所有散点数据
        // 如果想在地图中显示散点的数据, 我们需要给散点的图表增加一个配置, coordinateSystem:geo
        return {
          type: "scatter", // effectScatter
          rippleEffect: {
            scale: 3,
            brushType: "stroke",
            color: "rgb(255,255,0)",
          },
          data: item,
          color: "#2B96CB",
          symbolSize: 5,
          coordinateSystem: "geo",
        };
      });
      tempSeriesArr.push({
        name: "地区数据",
        type: "map",
        top: "0%",
        left: "27.8%",
        bottom: "20%",
        zoom: 0.89,
        mapType: "yancheng", // 自定义扩展图表类型
        itemStyle: {
          areaColor: "#0C30AD",
          borderColor: "rgba(146,211,255,0.7)",
          borderWidth: 1,
        },
      });
      const seriesArr = tempSeriesArr;

      const dataOption = {
        color: ["rgb(255,255,0)"],
        label: {
          fontSize: 12,
        },
        legend: {
          show: false,
        },
        series: seriesArr,
      };
      this.chartInstance.setOption(dataOption);
    },
    screenAdapter() {
      const titleFontSize = (this.$refs.map_ref.offsetWidth / 100) * 3.6;
      const adapterOption = {
        title: {
          textStyle: {
            fontSize: titleFontSize,
          },
        },
        legend: {
          itemWidth: titleFontSize / 2,
          itemHeight: titleFontSize / 2,
          itemGap: titleFontSize / 2,
          textStyle: {
            fontSize: titleFontSize / 2,
          },
          show: false,
        },
      };
      this.chartInstance.setOption(adapterOption);
      this.chartInstance.resize();
    },
    // 回到中国地图
    revertMap() {
      window.open("https://my.515ugx.com:20082/hotmap");
    },
  },
};
</script>

<style lang="less" scoped></style>